import { Card, CardContent, Divider, Grid, Typography } from "@mui/material";
import React from "react";

import Loading from "components/common/loading/Loading";
import RevenueChart from "components/pages/dashboard/revenue_analytic/chart/RevenueChart";
import RevenueStat from "components/pages/dashboard/revenue_analytic/RevenueStat";

import { useGetRevenueAnalyticQuery } from "app/store/dashboard/revenue_analytic/revenueAnalyticApi";

const RevenueAnalytic = () => {
  const { data, isLoading } = useGetRevenueAnalyticQuery();

  return (
    <Card
      elevation={0}
      style={{
        border: "1px solid #E0E0E0",
        borderRadius: "4px",
        height: "100%",
      }}
    >
      <CardContent>
        <Grid
          container
          flex={1}
          alignItems="center"
          justifyContent="space-between"
          sx={{ marginBottom: "20px" }}
        >
          <Grid item>
            <Typography
              variant="h6"
              style={{ fontSize: "1.125rem", fontWeight: 500 }}
            >
              Total Revenue
            </Typography>
          </Grid>
        </Grid>
        {isLoading ? (
          <Loading height="300px" />
        ) : (
          <>
            <RevenueStat data={data} />

            <Divider style={{ marginBottom: "10px" }} />

            <Grid container item flex={1}>
              <RevenueChart data={data} />
            </Grid>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default RevenueAnalytic;
